import React from 'react';
import { connect } from 'react-redux';

import ProgressSteps from './FormStepComponent';
import styles from './FormStep.css';

class FormStep extends React.Component {
  render() {
    const {
      createRecipesForm: { step },
    } = this.props;
    return (
      <div className={styles['step-container']}>
        <ProgressSteps steps={4} current={step} />
        <br />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state.ingredients.recipes,
  };
}

export default connect(mapStateToProps)(FormStep);
